import { selector } from "recoil"

import { Plan } from "../../interfaces"

import useCurrentService from "./currentService"
import useCurrentTeam from "./currentTeam"
import usePlans from "./plans"

const useCurrentPlan = selector({
  key: "currentPlan",
  // まだ読めていないときは null。上限 0 のダミープランを返すと、読み込み前の
  // 画面が「メンバー数 0 / 独自ドメイン 0 / ビルド時間 0min」と描いてしまう。
  get({ get }): Plan | null {
    const currentService = get(useCurrentService)

    const currentTeam = get(useCurrentTeam)
    if (currentTeam.id === "") return null

    const plans = get(usePlans)
    if (!plans.list.length) return null

    return (
      plans.list.find(
        (p) => p.planType === currentTeam.planTypes[currentService.name],
      ) ?? null
    )
  },
})

export default useCurrentPlan
